import { message as antdMessage, Button, Form, FormProps, Input } from 'antd';
import React, { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { buildApiUrl } from '@/global';
import { usePost } from '@/shared/hook/usePost';
import AuthLayout from './AuthLayout';

type FieldType = {
  email?: string;
};

type ResetPasswordResponse = {
  resultado?: boolean;
  mensaje?: string;
};

const RecoverPassword: React.FC = () => {
  const navigate = useNavigate();
  const [messageApi, contextHolder] = antdMessage.useMessage();

  const postRecover = usePost(buildApiUrl('/Cuenta/reset-password'));

  const onFinish: FormProps<FieldType>['onFinish'] = async (data) => {
    try {
      const response = (await postRecover.postData({ correo: data.email! })) as ResetPasswordResponse;

      if (response?.resultado) {
        messageApi.success(response.mensaje || 'Correo enviado correctamente.');
        setTimeout(() => {
          navigate('/login');
        }, 2000);
      } else {
        messageApi.error(response?.mensaje || 'No se pudo enviar el correo.');
      }
    } catch (err: unknown) {
      const errorMsg = err instanceof Error ? err.message : String(err);
      messageApi.error('No se pudo conectar con el servidor. ' + errorMsg);
      return;
    }
  };

  return (
    <Fragment>
      {contextHolder}
      <AuthLayout
        title="Recupera tu contraseña"
        hint="Te enviaremos un correo con las instrucciones para restablecerla."
      >
        <Form name="recover" layout="vertical" onFinish={onFinish} autoComplete="off">
          <Form.Item<FieldType>
            label="Correo Electrónico"
            name="email"
            rules={[{ required: true, message: 'Por favor ingresa tu correo electrónico', type: 'email' }]}
          >
            <Input placeholder="correo@example.com" />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" style={{ width: '100%' }}>
              Enviar
            </Button>
          </Form.Item>

          <div className="row2" style={{ justifyContent: 'center' }}>
            <a className="forgot" onClick={() => navigate('/login')}>
              Volver al inicio de sesión
            </a>
          </div>
        </Form>
      </AuthLayout>
    </Fragment>
  );
};

export default RecoverPassword;
